<template>
  <Top />
</template>

<script>
import Top from '@/components/Top.vue'
export default {
  components: {
    Top
  }
}
</script>

<style scoped></style>
